module.exports = __webpack_public_path__ + "static/media/icon_back.a9575522.png";